/**
 * Content Block Widget Default Configuration
 *
 * Rich text content widget for displaying formatted text, images, and media.
 */

export interface ContentBlockWidgetConfig {
  displayName: string;
  htmlContent: string;
  showBorder: boolean;
  backgroundColor: string;
  padding: number;
  textAlignment: 'left' | 'center' | 'right' | 'justify';
}

export const CONTENT_BLOCK_DEFAULT_CONFIG: ContentBlockWidgetConfig = {
  displayName: 'Content Block',
  htmlContent: '',
  showBorder: false,
  backgroundColor: 'transparent',
  padding: 16,
  textAlignment: 'left',
};

/**
 * Create default configuration for a content block widget
 */
export const createContentBlockConfig = (): ContentBlockWidgetConfig => ({
  ...CONTENT_BLOCK_DEFAULT_CONFIG,
});

export default createContentBlockConfig;
